<template>
  <div>
    <div
      v-if="!loadingStatus"
      class="z-20 hover:opacity-90 fixed top-0 left-0 w-full sm:w-max sm:top-5 sm:left-5 h-8 sm:h-auto text-center cursor-pointer text-xs px-2 py-2 sm:rounded"
      :style="{
        color: survey.buttons[0].fontColor,
        'background-color': survey.buttons[0].bgColor,
        'border-color': survey.buttons[0].borderColor,
      }"
    >
      <router-link
        :to="{ path: '/builder/' + survey.id }"
        class="flex flex-row justify-center hover:no-underline"
      >
        <svg-icon
          icon="heroicons/outline/chevron-double-left"
          class="h-6 w-6"
        ></svg-icon>
        <span class="px-4 text-base font-semibold my-auto">Exit preview </span>
      </router-link>
    </div>

    <WidgetMain
      :surveyid="surveyid"
      :stepid="stepId"
      :pixelData="pixelData"
      @close-widget="closeWidget"
    ></WidgetMain>
  </div>
</template>

<script>
import Survey from "@/models/Survey";
//import NavBar from "@/components/Navbar";
import WidgetMain from "@/WidgetMain";
import router from "@/router/route.js";

export default {
  components: { WidgetMain },
  props: ["surveyid" /*"pixelData"*/],
  data() {
    return {
      loadingStatus: true,
    };
  },
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .with("buttons")
        .with("steps", (query) => {
          query.orderBy("order", "asc").with("options", (query) => {
            query.orderBy("order", "asc");
          });
        })
        .first();
    },
    stepId() {
      return this.$route.params.id || null;
    },
    pixelData() {
      return {
        email: "bert@sampson.com",
        user_id: "axa124sga",
        name: "Bart Sampson",
      };
    },
  },
  methods: {
    async init() {
      var id = this.surveyid || null;

      if (id === null) {
        console.log("Error, survey not found.");
        this.$destroy();
      }

      this.loadingStatus = true;

      //if survey is not already loaded in state, request it from the server
      if (this.survey === null) {
        await Survey.api().get("/api/survey/" + id, {
          dataKey: "data",
        });
      }

      this.loadingStatus = false;
    },
    closeWidget() {
      router.push({ path: "/builder/" + this.survey.id });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
a:hover {
  color: inherit; /* Inherits color property from its parent */
}
</style>
